import { LOGIN_SUCCESS, LOGOUT_SUCCESS } from './constants'

const LOGIN_CHANGE = 'login-change'

const middleware = store => next => action => {
  if (![LOGIN_SUCCESS, LOGOUT_SUCCESS].includes(action.type)) {
    return next(action)
  }

  const {
    login: { isLoggedIn },
  } = store.getState()

  const event = new CustomEvent(LOGIN_CHANGE, { detail: { isLoggedIn } })

  window.dispatchEvent(event)

  return next(action)
}

export default middleware
